import React, { useState, useEffect } from 'react';
import { Grid, Backdrop, CircularProgress, Typography, TextField, Button, IconButton, Alert, Select, MenuItem, Divider, Stack, Tooltip } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
// project imports
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { PatternFormat } from 'react-number-format';
import InputAdornment from '@mui/material/InputAdornment';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';

import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

// ==============================|| PROFILE 1 - PROFILE ACCOUNT ||============================== //

const styles = {
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
};

const Phones = ({ EmployeeNr }) => {

  const theme = useTheme();


  if (EmployeeNr === 0) {
    return (
        <Grid container spacing={2}>
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 12
            }}>
            <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
              <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
              </Typography>
            </Alert>        </Grid>
        </Grid>
    );
  }

  const [phones, setPhones] = useState([]); // Örnek telefon listesi
  const [yetki, setYetki] = useState([]);
  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);
  const PhonesTypes = [
    { id: 1, type: 'Genel Mobil İletişim Hizmeti(Gsm)' },
    { id: 2, type: 'İş Telefonu' },
    { id: 6, type: 'Randevu Bilgilendirme' },
    { id: 5, type: 'Bilgilendirme İçin Gsm' },
    { id: 7, type: 'Acil Durum Telefonu' }
  ];
  const [newPhoneType, setNewPhoneType] = useState('');
  const [newPhoneNumber, setNewPhoneNumber] = useState('');

  const handleAddPhone = () => {
    // const newPhone = { id: Date.now(), type: newPhoneType, number: newPhoneNumber };
    // setPhones([...phones, newPhone]);

    setLoading(true);
    axios.get(`SetEmplyeePhones/${EmployeeNr}/${newPhoneType}/${newPhoneNumber.replace(" ", "").replace("-", "").replace("(", "").replace(")", "").trim()}/0/1`).then((response) => {
      setNewPhoneType('');
      setNewPhoneNumber('');
      getEmployeePhones();
      setLoading(false);
    });
  };

  const handleDeletePhone = (id) => {

    confirmAlert({
      message: "Telefon silinecektir!... Devam etmek istediginizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleDeletePhoneParam(id)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });

  };

  const handleDeletePhoneParam = (id) => {


    setLoading(true);
    axios.get(`SetEmplyeePhones/${EmployeeNr}/0/0/${id}/0`).then((response) => {
      getEmployeePhones();
      setLoading(false);
    });
  };





  const getEmployeePhones = () => {
    setLoading(true);
    axios.get(`GetEmplyeePhone/${EmployeeNr}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setPhones(response.data);
        } else {
          setPhones([]);
        }
        setLoading(false);
      });

  }

  const getEmployeeYetki = () => {
    setLoading(true);
    axios.get(`GetEmployeeYetki`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setYetki(response.data);
        } else {
          setYetki([]);
        }
        setLoading(false);
      });

  }

  useEffect(() => {
    getEmployeePhones();
    getEmployeeYetki();
  }, []);

  return (
    <div>
      {loading && (
        <Backdrop sx={styles.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Grid container spacing={4}>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <Typography variant="h5" sx={{ mb: 1 }}>İletişim Bilgileri</Typography>
          <Divider sx={{ mb: 2 }} />
          {phones.length > 0 ? (
            <Stack divider={<Divider />} spacing={1.5}>
              {phones.map((phone) => (
                <Grid container spacing={2} alignItems="center" key={phone.id}>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 4
                    }}>
                    <Typography variant="subtitle1">{phone.type}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3
                    }}>
                    <Typography>{phone.number}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3
                    }}>
                    <Typography color="text.secondary">{phone.Date}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 2
                    }}
                    sx={{ textAlign: 'right' }}>
                    <Tooltip title="Sil">
                      <span>
                        <IconButton onClick={() => handleDeletePhone(phone.id)}
                          disabled={yetki.find(item => item.ALAN_ADI === 'dsDeletePhone')?.DISABLE_ALAN}
                        >
                          <Delete style={{ color: 'red' }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>
              ))}
            </Stack>
          ) : (
            <Typography color="text.secondary">Kayıtlı iletişim bilgisi bulunmamaktadır.</Typography>
          )}
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 6
          }}
          sx={{
            borderLeft: { md: '1px solid' },
            borderColor: 'divider',
            pl: { md: 4 }
          }}>
          <Typography variant="h5" sx={{ mb: 1 }}>Yeni İletişim Ekle</Typography>
          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={2}>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 6
              }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-age-native-simple">Telefon Tipi</InputLabel>
                <Select
                  variant="outlined"
                  label="Telefon Tipi"
                  value={newPhoneType}
                  onChange={(e) => setNewPhoneType(e.target.value)}
                  fullWidth
                  disabled={yetki.find(item => item.ALAN_ADI === 'dsNewPhoneType')?.DISABLE_ALAN}
                  size="small"
                  inputProps={{
                    name: 'age',
                    id: 'outlined-age-native-simple',
                  }}
                >
                  {PhonesTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 6
              }}>
              <FormControl variant="outlined" fullWidth>
                <PatternFormat
                  format="(###) ###-####"
                  mask="_"
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={newPhoneNumber}
                  onChange={(e) => setNewPhoneNumber(e.target.value)}
                  disabled={yetki.find(item => item.ALAN_ADI === 'dsNewPhoneNumber')?.DISABLE_ALAN}
                  customInput={TextField}
                  label="Telefon Numarası"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIphoneIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Grid>
            <Grid
              style={{ textAlign: "right" }}
              size={{
                xs: 12,
                sm: 12,
                md: 12
              }}>
              <Button variant="contained"
                color="secondary"
                style={{ textTransform: 'none' }}
                startIcon={<AddIcCallIcon />}
                onClick={handleAddPhone}
                disabled={yetki.find(item => item.ALAN_ADI === 'dsAddPhone')?.DISABLE_ALAN}
              >
                Ekle
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Phones;
